import { render, staticRenderFns } from "./isi-info.vue?vue&type=template&id=2dd07f22&"
import script from "./isi-info.vue?vue&type=script&lang=ts&"
export * from "./isi-info.vue?vue&type=script&lang=ts&"
import style0 from "./isi-info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports